var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 45,
    viewBox: "0 0 162 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2293_28951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8719 29.2519C39.4277 29.2519 38.9873 29.2519 38.5431 29.2519V27.8771H35.7897V26.5023H34.415C34.415 26.0351 34.415 25.5794 34.415 25.1276H35.7897V23.7528H37.1645V22.378H38.5622V8.61895H37.1645V7.24419H34.4111V5.86943H31.6616V4.49467H28.9083V3.11991H16.5278V1.74515H13.7782V0.362732H8.27537V1.73749H5.52202V3.11225H1.39774V25.1237H0V33.38H1.39774V34.7547H4.14726V36.1295H6.90061V37.5042H9.65013V38.879H12.4035V40.2538H15.153V41.6285H17.9064V43.0033H20.6597V44.3589H26.1626V43.0033H27.5527C27.7403 43.0033 27.9165 43.0033 28.0926 43.0033H28.4258C28.5292 43.0033 28.6517 43.0033 28.7551 43.0033H28.9159V41.6285H31.6654V40.2538H34.415V38.879H37.1683V37.5042H39.9408V29.248H39.8719V29.2519Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90463 3.11609H8.27939V1.74133H13.7823V3.11609H16.5356V4.48703H19.2775V5.86944H22.0385V7.2442H24.7918V8.61897H27.5452V9.99373H28.9199V11.38H27.5337V12.7432H23.4171V11.3685H20.6637V9.99373H17.9104V8.61897H15.157V7.2442H12.4037V5.86944H9.65032V4.49468H6.89697V3.11992L6.90463 3.11609Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77637 26.5023V25.1276H4.15113V26.5023H2.77637Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.04 9.99372H34.4148V8.61896H37.1681V22.3781H35.7934V23.7528H34.4646C34.4646 23.7528 34.4416 23.772 34.4339 23.7834C34.4263 23.7949 34.4186 23.8103 34.4186 23.8217C34.4186 24.7063 34.4186 25.5871 34.4186 26.5023H33.0439V9.99372H33.04Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1684 29.2518V30.6228H34.4265V32.0052H30.2907V33.3799H28.916V34.7547H26.1626V36.1295H23.4131V41.6323H26.1626V40.2576H28.916V38.8828H31.6655V37.5081H34.4188V36.1333H37.1722V34.7585H38.5469V29.2557H37.1722L37.1684 29.2518Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7876 12.7432H27.5295V11.38H28.9157V9.99371H30.2905V30.6304C30.0377 30.6304 29.808 30.6304 29.582 30.6304C29.3599 30.6343 29.134 30.6113 28.9157 30.6458V32.0052H26.1624V33.38H24.7876V12.7432Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15088 26.5023H5.52564V27.8771H4.15088V26.5023Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2793 9.99371H11.0326V11.3685H13.786V12.7432H16.5393V14.118H19.2927V15.4774C19.511 15.5157 19.7369 15.4889 19.959 15.4928C20.185 15.4966 20.4109 15.4928 20.6675 15.4928V26.4985H19.2927V25.1237H16.5393V23.749H13.786V22.3742H11.0326V20.9995H8.2793V9.99371Z",
    fill: "#E81717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9043 27.8771V29.2518H9.65765V27.8771H6.9043Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65381 29.2518V30.6266H12.4072V29.2518H9.65381Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 30.6304V32.0052H15.1567V30.6304H12.4072Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1567 32.0052V33.38H17.9101V32.0052H15.1567Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9102 34.7547H20.6597V33.3799H17.9102V34.7547Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6597 34.7547V36.1295C21.349 36.1295 20.6597 36.1295 21.349 36.1295H23.413V34.7547H20.6635H20.6597Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15088 26.5023V27.8771H6.9004V26.5023H4.15088Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40137 25.1276V26.5023H4.15472V25.1276H1.40137Z",
    fill: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2852 26.5023V27.8771H20.6599V26.5023H19.2852Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2793 20.9995V22.3742H11.0326V20.9995H8.2793Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0288 22.3742V23.749H13.7783V22.3742H11.0288Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 23.749V25.1237H16.5356V23.749H13.7822Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5317 25.1276V26.5023H19.2813V25.1276H16.5317Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27909 8.61896H6.88135V20.9995H8.27909V8.61896Z",
    fill: "#AD1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6595 11.3685H17.91V9.99373H15.1566V8.61897H12.4071V7.24421H9.65375V5.86945H6.9004V4.49469H4.15088V25.1314H6.9004V26.5062H9.65375V27.8809H12.4071V29.2557H15.1566V30.6305H17.91V32.0052H20.6595V33.38H23.4128V12.7433H20.6595V11.3685ZM21.9845 14.1218C21.9845 14.1218 22.0075 14.141 22.0189 14.1525C22.0266 14.164 22.0343 14.1793 22.0343 14.1908C22.0343 19.1958 22.0343 24.2009 22.0343 29.2136C22.0266 29.2212 22.0151 29.2327 22.0036 29.2404C21.9921 29.248 21.9768 29.2557 21.9653 29.2557C21.0807 29.2557 20.2 29.2557 19.2847 29.2557V27.8809H16.5352V26.5062H13.7819V25.1314H11.0323V23.7567H8.27899V22.3819H5.57925C5.57925 22.3819 5.55627 22.3627 5.54479 22.3513C5.53713 22.3398 5.52947 22.3245 5.52947 22.313C5.52947 17.3079 5.52947 12.3029 5.52947 7.29016C5.53713 7.28251 5.54862 7.27102 5.5601 7.26336C5.57159 7.2557 5.58691 7.24804 5.5984 7.24804C6.48299 7.24804 7.36376 7.24804 8.27899 7.24804V8.6228H11.0323V9.99756H13.7819V11.3723H16.5352V12.7471H19.2847V14.1218H21.9845Z",
    fill: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2851 34.7547H16.5355V33.38H13.7822V32.0052H11.0327V30.6304H8.27932V29.2557H5.52979V27.8809H4.15503V26.5062H2.78027V33.3838H4.15503V34.7586H6.90456V36.1333H9.65791V37.5081H12.4113V38.8828H15.1608V40.2576H17.9141V41.6324H20.6636V43.0071H22.0384V36.1295H19.2851V34.7509V34.7547Z",
    fill: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6657 7.24037V5.86561H28.9123V4.49084H22.0347V5.86561H24.788V7.24037H27.5375V8.61513H30.2909V9.98989H34.419V7.23654H31.6695L31.6657 7.24037Z",
    fill: "#EFF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1626 41.6362H28.9159V40.2614H26.1626V41.6362Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4131 43.0109H26.1626V41.6362H23.4131V43.0109Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4189 37.5081H37.1723V36.1333H34.4189V37.5081Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1685 34.7547V36.1295H38.5432V34.7547H37.1685Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0403 26.5023V9.99371H31.6655V27.8771H33.0403V26.5023Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.916 40.2576H31.6655V38.8828H28.916V40.2576Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6655 38.8828H34.4189V37.5081H31.6655V38.8828Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9159 33.3799H26.1626V34.7547H28.9159V33.3799Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1626 34.7547H23.4131V36.1295H26.1626V34.7547Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8832 29.2518H32.55C32.4926 29.2518 32.4313 29.2518 32.3739 29.2518C32.3241 29.2518 32.2705 29.2518 32.2169 29.2518H31.6616V32.0052H34.4226V30.6228H37.1645V29.2518H35.7897V27.8771H33.0364V29.2365C32.9828 29.2442 32.9292 29.2518 32.8755 29.2557L32.8832 29.2518Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2908 33.38H31.6655V32.0128H30.2908V32.0052H28.916V33.38H30.2908Z",
    fill: "#8D969E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 0.362732H8.2793V1.73749H13.7822V0.362732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2775 4.48319V5.86561H22.0385V4.54063C22.0385 4.54063 22.0577 4.51766 22.0692 4.50617C22.0806 4.49851 22.096 4.49085 22.1074 4.49085C24.3783 4.49085 26.6491 4.49085 28.9162 4.49085V3.11609H16.5356V4.48702H19.2775V4.48319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4189 7.24036V5.8656H31.6655V7.24036H34.4189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6655 5.86561V4.49084H28.916V5.86561H31.6655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9102 41.6362V43.0109H20.6597V41.6362H17.9102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.916 41.6362H31.6655V40.2614H28.916V41.6362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1567 40.2576V41.6323H17.9101V40.2576H15.1567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6655 40.2576H34.4189V38.8828H31.6655V40.2576Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5317 3.11609V1.74133H13.7783V3.11609H16.5317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1682 29.2518H38.543V27.8771H35.7935V29.2518H37.1682Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 38.8828V40.2576H15.1567V38.8828H12.4072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27931 3.11609V1.74133H5.52979V3.11609H8.27931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1684 8.61896V7.2442H34.415V8.61896H37.1684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4189 38.8828H37.1723V37.5081H34.4189V38.8828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65381 37.5081V38.8828H12.4072V37.5081H9.65381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77633 33.38H1.40157V25.1237H4.15109V23.749H2.82228C2.74952 23.3316 2.72272 6.24854 2.79164 4.487H5.52968V3.11224H1.40157V25.1237H0V33.38H1.39774V34.7547H4.15109V33.38H2.77633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15088 34.7547V36.1295H6.9004V34.7547H4.15088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9043 36.1333V37.5081H9.65765V36.1333H6.9043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7935 23.749H37.1682V22.3742H35.7935V23.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0347 5.8656V7.24036H24.788V5.8656H22.0347Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7876 7.24036V8.61512H27.5371V7.24036H24.7876Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5371 8.61896V9.99372H30.2905V8.61896H27.5371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.413 33.3799H20.6597V34.7547H26.1625V33.3799H23.413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5317 12.7432V11.3685H13.7783V12.7432H16.5317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2852 14.1218V12.7471H16.5356V14.1218H19.2852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0287 23.749V22.3742H8.27539V23.749H11.0287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5317 26.5023V25.1276H13.7783V26.5023H16.5317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 25.1276V23.7528H11.0327V25.1276H13.7822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 11.3685V9.99371H11.0327V11.3685H13.7822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15088 25.1276V26.5023H6.9004V25.1276H4.15088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0287 9.99372V8.61896H8.27539V9.99372H11.0287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9043 26.5023V27.8771H9.65765V26.5023H6.9043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2852 27.8771V26.5023H16.5356V27.8771H19.2852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65381 27.8771V29.2518H12.4072V27.8771H9.65381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 29.2518V30.6266H15.1567V29.2518H12.4072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1567 30.6304V32.0052H17.9101V30.6304H15.1567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9102 32.0052V33.38H20.6597V32.0052H17.9102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5279 22.3742H38.5662V8.61896H37.1685V22.3781H38.5279V22.3742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.872 29.2519C39.4278 29.2519 38.9874 29.2519 38.5432 29.2519V36.1295H37.1685V37.5043H39.941V29.248H39.872V29.2519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52588 8.61898V22.3781H8.2754V21.0033H6.94659C6.92745 20.8923 6.91213 20.0536 6.90064 18.8627V9.25083C6.90447 8.9866 6.9083 8.76833 6.91596 8.62281H8.2754V7.24805H5.52588V8.62281V8.61898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0347 27.8771C22.0347 23.749 22.0347 19.6209 22.0347 15.4966V14.1218H19.2852V15.4966H19.446C19.557 15.5042 19.6643 15.4966 19.7753 15.4966H20.1123C20.2885 15.4966 20.4646 15.4966 20.6599 15.4966V27.8771H19.2852V29.2519H22.0347V27.8771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4189 23.749V25.1237H35.7937V23.749H34.4189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0402 26.5023H31.6655V9.99371H30.2907V30.6304C30.0954 30.6304 29.9154 30.6304 29.7393 30.6304H29.4061C29.2951 30.6304 29.184 30.6228 29.0768 30.6304H28.9159V32.0052H26.1626V33.38H28.9159V32.0129H31.6693V29.2519C31.8684 29.2519 32.0484 29.2519 32.2246 29.2519H33.0479V27.8771H35.8012V26.5023H34.4265V25.1276H33.0517V26.5023H33.0402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.413 43.0109H20.6597V44.3665H26.1625V43.0109H23.413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1626 43.0109H27.5527C27.7403 43.0109 27.9165 43.0109 28.0926 43.0109H28.4258C28.5292 43.0109 28.6517 43.0109 28.7551 43.0109H28.9159V41.6362H26.1626V43.0109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82242 23.749H4.15123V4.49084H2.79178C2.72285 6.25238 2.75349 23.3354 2.82242 23.7528V23.749Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52588 3.11609V4.49085H6.90064V3.11609H5.52588Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4131 12.7432V33.38H24.7878V12.7432H23.4131Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9102 9.99371V11.3685H20.6597V9.99371H17.9102Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65381 5.8656V7.24036H12.4072V5.8656H9.65381Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6597 11.3685V12.7432H23.413V11.3685H20.6597Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9043 4.49084V5.86561H9.65765V4.49084H6.9043Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 7.24036V8.61512H15.1567V7.24036H12.4072Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1567 8.61896V9.99372H17.9101V8.61896H15.1567Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5317 34.7547H17.9065V33.3799H16.5317V34.7547Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7822 33.38H15.157V32.0052H13.7822V33.38Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0288 32.0052H12.4036V30.6304H11.0288V32.0052Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2793 30.6304H9.65406V29.2557H8.2793V30.6304Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40137 33.3799H2.77613V26.7014C2.77613 26.7014 2.77613 26.6708 2.77613 26.4985H1.40137V33.3761V33.3799Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52588 29.2518H6.90064V27.8771H5.52588V29.2518Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2852 36.1333H20.6599V34.7585H19.2852V36.1333Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0347 43.0109H23.4094V36.1333H22.0347V43.0109Z",
    fill: "#DDE3E8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8948 17.0915V17.1415H51.9448H53.4904H53.5404V17.0915V10.9593H59.6727H59.7227V10.9093V9.36368V9.31368H59.6727H53.5404V4.77697H61.2183H61.2683V4.72697V3.1814V3.1314H61.2183H51.9448H51.8948V3.1814V17.0915Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.533 17.0915V17.1415H65.583H70.2197H70.2697V17.0915V15.546V15.496H70.2197H68.7242V4.77697H70.2197H70.2697V4.72697V3.1814V3.1314H70.2197H65.583H65.533V3.1814V4.72697V4.77697H65.583H67.0786V15.496H65.583H65.533V15.546V17.0915Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.534 17.0915V17.1415H74.584H76.1296H76.1796V17.0915V10.9593H79.1707V12.4548V12.5048H79.2207H80.7163V15.546V15.596H80.7663H82.2618V17.0915V17.1415H82.3118H83.8574H83.9074V17.0915V15.546V15.496H83.8574H82.3618V12.4548V12.4048H82.3118H80.8163V10.9593H82.3118H82.3618V10.9093V9.41368H83.8574H83.9074V9.36368V4.72697V4.67697H83.8574H82.3618V3.1814V3.1314H82.3118H74.584H74.534V3.1814V17.0915ZM82.2618 9.31368H76.1796V4.77697H82.2618V9.31368Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2464 17.0915V17.1415H88.2964H97.5698H97.6198V17.0915V15.546V15.496H97.5698H89.892V10.9593H96.0242H96.0742V10.9093V9.36368V9.31368H96.0242H89.892V4.77697H97.5698H97.6198V4.72697V3.1814V3.1314H97.5698H88.2964H88.2464V3.1814V17.0915Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.181 7.81811V7.86811H102.231H103.727V14.0004V14.0504H103.777H105.273V17.0915V17.1415H105.323H106.868H106.918V17.0915V14.0504H108.414H108.464V14.0004V9.41368H109.959H110.009V9.36368V6.32254H111.455V9.36368V9.41368H111.505H113V14.0004V14.0504H113.05H114.546V17.0915V17.1415H114.596H116.142H116.192V17.0915V14.0504H117.687H117.737V14.0004V7.86811H119.233H119.283V7.81811V3.1814V3.1314H119.233H117.687H117.637V3.1814V7.76811H116.142H116.092V7.81811V13.9504H114.646V9.36368V9.31368H114.596H113.1V6.27254V6.22254H113.05H111.555V3.1814V3.1314H111.505H109.959H109.909V3.1814V6.22254H108.414H108.364V6.27254V9.31368H106.868H106.818V9.36368V13.9504H105.373V7.81811V7.76811H105.323H103.827V3.1814V3.1314H103.777H102.231H102.181V3.1814V7.81811Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.667 13.9504H121.617V14.0004V17.0915V17.1415H121.667H123.213H123.263V17.0915V14.0504H132.436V17.0915V17.1415H132.486H134.032H134.082V17.0915V14.0004V13.9504H134.032H132.536V9.36368V9.31368H132.486H130.99V6.27254V6.22254H130.94H129.445V3.1814V3.1314H129.395H126.304H126.254V3.1814V6.22254H124.758H124.708V6.27254V9.31368H123.213H123.163V9.36368V13.9504H121.667ZM130.89 9.41368V12.4048H124.808V9.41368H126.304H126.354V9.36368V6.32254H129.345V9.36368V9.41368H129.395H130.89Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.717 17.0915V17.1415H138.767H148.041H148.091V17.0915V15.546V15.496H148.041H140.363V3.1814V3.1314H140.313H138.767H138.717V3.1814V17.0915Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.504 17.0915V17.1415H152.554H161.827H161.877V17.0915V15.546V15.496H161.827H154.149V3.1814V3.1314H154.099H152.554H152.504V3.1814V17.0915Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2078 39.9985V40.0485H88.2578H89.7534V41.5441V41.5941H89.8034H95.9857H96.0357V41.5441V40.0485H97.5312H97.5812V39.9985V38.453V38.403H97.5312H95.9857H95.9357V38.453V39.9485H89.8534V36.9574H97.5312H97.5812V36.9074V32.2707V32.2207H97.5312H96.0357V30.7251V30.6751H95.9857H89.8034H89.7534V30.7251V32.2207H88.2578H88.2078V32.2707V39.9985ZM95.9357 32.3207V35.3118H89.8534V32.3207H95.9357Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7269 41.5441V41.5941H78.7769H80.2997H80.3497V41.5441V32.4573H84.868H84.918V32.4073V30.8845V30.8345H84.868H80.3497V27.889H84.868H84.918V27.839V26.3162V26.2662H84.868H80.2997H80.2497V26.3162V27.789H78.7769H78.7269V27.839V41.5441Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.512 39.9985V40.0485H65.562H67.0576V41.5441V41.5941H67.1076H71.7443H71.7943V41.5441V40.0485H73.2399V41.5441V41.5941H73.2899H74.8354H74.8854V41.5441V32.2707V32.2207H74.8354H73.3399V30.7251V30.6751H73.2899H67.1076H67.0576V30.7251V32.2707V32.3207H67.1076H73.2399V33.7662H67.1076H67.0576V33.8162V35.3118H65.562H65.512V35.3618V39.9985ZM67.1576 39.9485V35.4118H73.2399V38.403H71.7443H71.6943V38.453V39.9485H67.1576Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8948 38.453V38.503H51.9448H53.4404V39.9985V40.0485H53.4904H54.986V41.5441V41.5941H55.036H61.2183H61.2683V41.5441V39.9985V39.9485H61.2183H55.086V38.453V38.403H55.036H53.5404V30.7751H55.036H55.086V30.7251V29.2295H61.2183H61.2683V29.1795V27.634V27.584H61.2183H55.036H54.986V27.634V29.1295H53.4904H53.4404V29.1795V30.6751H51.9448H51.8948V30.7251V38.453Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.266 41.5441V41.5941H105.316H106.695H106.745V41.5441V37.4577H108.024V38.7865V38.8365H108.074H109.452H109.502V38.7865V37.4577H110.831H110.881V37.4077V33.2712V33.2212H110.831H109.502V31.8924V31.8424H109.452H108.124V30.5636H109.452H109.502V30.5136V29.1848H113.539V35.9789H112.21H112.16V36.0289V38.7365H110.831H110.781V38.7865V40.1153H109.452H109.402V40.1653V41.5441V41.5941H109.452H110.831H110.881V41.5441V40.2153H112.21H112.26V40.1653V38.8365H113.589H113.639V38.7865V36.0789H114.968H115.018V36.0289V33.3212H119.054V40.1153H117.775V38.7865V38.7365H117.725H116.346H116.296V38.7865V40.1653V40.2153H116.346H117.675V41.5441V41.5941H117.725H119.104H119.154V41.5441V40.2153H120.483H120.533V40.1653V31.8924V31.8424H120.483H115.018V29.1848H121.862H121.912V29.1348V27.756V27.706H121.862H117.775V26.3772V26.3272H117.725H116.396V24.9984V24.9484H116.346H114.968H114.918V24.9984V26.3772V26.4272H114.968H116.296V27.706H110.881V24.9984V24.9484H110.831H105.316H105.266V24.9984V41.5441ZM109.402 37.3577H108.124V36.0289V35.9789H108.074H106.745V31.9424H108.024V33.2712V33.3212H108.074H109.402V37.3577ZM108.024 30.4636H106.745V26.4272H109.402V29.0848H108.074H108.024V29.1348V30.4636Z",
    fill: "#E81717",
    stroke: "#E81717",
    strokeWidth: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.985 41.5441V41.5941H126.035H128.79H128.84V41.5441V40.2153H130.168H130.218V40.1653V38.8365H131.545H131.595V38.7865V37.4577H132.923H132.973V37.4077V34.7H134.251V36.0289V36.0789H134.301H135.629V37.4077V37.4577H135.679H137.006V38.7865V38.8365H137.056H138.384V40.1653V40.2153H138.434H139.762V41.5441V41.5941H139.812H141.189H141.239V41.5441V40.1653V40.1153H141.189H139.862V38.7865V38.7365H139.812H138.484V37.4077V37.3577H138.434H137.106V36.0289V35.9789H137.056H135.729V34.65V34.6H135.679H134.351V24.9984V24.9484H134.301H132.923H132.873V24.9984V34.6H131.545H131.495V34.65V37.3577H130.168H130.118V37.4077V38.7365H128.79H128.74V38.7865V40.1153H126.035H125.985V40.1653V41.5441ZM138.434 31.9424H138.484V31.8924V30.5636H139.812H139.862V30.5136V27.756V27.706H139.812H138.434H138.384V27.756V30.4636H137.056H137.006V30.5136V31.8424H135.679H135.629V31.8924V33.2712V33.3212H135.679H137.056H137.106V33.2712V31.9424H138.434ZM128.79 34.7H128.84V34.65V33.3212H130.168H130.218V33.2712V29.1348V29.0848H130.168H128.79H128.74V29.1348V33.2212H127.412H127.362V33.2712V34.65V34.7H127.412H128.79Z",
    fill: "#E81717",
    stroke: "#E81717",
    strokeWidth: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M145.312 38.7865V38.8365H145.362H148.12H148.17V38.7865V37.4577H152.206V41.5441V41.5941H152.256H161.908H161.958V41.5441V33.2712V33.2212H161.908H152.256H152.206V33.2712V35.9789H149.549V30.5636H150.828V31.8924V31.9424H150.878H161.908H161.958V31.8924V30.5136V30.4636H161.908H160.579V29.1848H161.908H161.958V29.1348V26.3772V26.3272H161.908H157.822V24.9984V24.9484H157.772H156.393H156.343V24.9984V26.3272H150.878H150.828V26.3772V27.756V27.806H150.878H152.206V29.0848H149.549V24.9984V24.9484H149.499H148.12H148.07V24.9984V29.0848H145.362H145.312V29.1348V30.5136V30.5636H145.362H148.07V37.3577H145.362H145.312V37.4077V38.7865ZM159.1 29.1348V30.4636H157.822V27.806H160.479V29.0848H159.15H159.1V29.1348ZM153.685 29.0848V27.806H156.343V30.4636H155.064V29.1348V29.0848H155.014H153.685ZM153.585 29.1848V30.4636H152.306V29.1848H153.585ZM155.014 35.9789H154.964V36.0289V40.1153H153.685V34.7H160.479V40.1153H159.2V36.0289V35.9789H159.15H155.014ZM156.443 40.1153V37.4577H157.722V40.1153H156.443Z",
    fill: "#E81717",
    stroke: "#E81717",
    strokeWidth: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2293_28951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9446,
    height: 44,
    fill: "white",
    transform: "translate(0 0.362732)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoName);
export default __webpack_public_path__ + "static/media/logo_name.f789043ddb8e9e430f82fe2e07b2f1d1.svg";
export { ForwardRef as ReactComponent };